import React from "react";
import { ButtonContained, ButtonText } from "../../../components";
import S from "../styles/StylesWebcam";
import { CircularProgress, MenuItem, Select } from "@mui/material";
import UploadImageTab from "./UploadImageTab";

interface AnteriorTabProps {
  facialFormat?: string;
  loading: boolean;
  anteriorOptions: { imageId: string; name: string }[];
  selectedAnteriorId: string;
  anteriorImageSrc: string | null;
  onSelectAnterior: (imageId: string) => void;
  onSubmit: (imgSrc: { src: string; name: string }) => void;
  onBack: () => void;
  showUploadImage?: boolean;
}

function AnteriorTab({
  facialFormat,
  loading,
  anteriorOptions,
  selectedAnteriorId,
  anteriorImageSrc,
  onSelectAnterior,
  onSubmit,
  onBack,
  showUploadImage,
}: AnteriorTabProps) {
  if (loading && anteriorOptions.length === 0) {
    return (
      <S.Container>
        <S.AnteriorEmptyMessage>
          <CircularProgress />
        </S.AnteriorEmptyMessage>
      </S.Container>
    );
  }

  if (anteriorOptions.length === 0) {
    if (showUploadImage) {
      return (
        <UploadImageTab
          facialFormat={facialFormat}
          onConfirm={onSubmit}
          onBack={onBack}
        />
      );
    }
    return (
      <S.Container>
        <S.AnteriorEmptyMessage>
          Nenhuma imagem anterior encontrada.
        </S.AnteriorEmptyMessage>
        <S.Actions>
          <ButtonText onClick={onBack}>Voltar</ButtonText>
        </S.Actions>
      </S.Container>
    );
  }

  return (
    <S.Container>
      <div style={{ width: "100%" }}>
        <Select
          fullWidth
          displayEmpty
          size="small"
          value={selectedAnteriorId}
          onChange={(e) => onSelectAnterior(e.target.value)}
          style={{ marginBottom: "0px", borderRadius: "0px" }}
          sx={{
            "& .MuiOutlinedInput-notchedOutline": {
              borderTop: "none",
              borderBottom: "none",
              borderLeft: "1px solid #E3E3E3",
              borderRight: "1px solid #E3E3E3",
              borderRadius: "0px",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderLeft: "1px solid #E3E3E3",
              borderRight: "1px solid #E3E3E3",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderLeft: "1px solid #E3E3E3",
              borderRight: "1px solid #E3E3E3",
            },
          }}
        >
          <MenuItem value="">Selecione uma facial</MenuItem>
          {anteriorOptions.map((opt) => (
            <MenuItem key={opt.imageId} value={opt.imageId}>
              {opt.name || opt.imageId}
            </MenuItem>
          ))}
        </Select>

        {loading ? (
          <S.AnteriorEmptyMessage>
            <CircularProgress />
          </S.AnteriorEmptyMessage>
        ) : anteriorImageSrc ? (
          <>
            <S.CapturedPhoto $src={anteriorImageSrc} />
            <S.Actions>
              <ButtonContained onClick={() => onSubmit({ src: anteriorImageSrc, name: "saved-photo" })}>
                Continuar
              </ButtonContained>
              <ButtonText onClick={onBack}>Voltar</ButtonText>
            </S.Actions>
          </>
        ) : (
          <S.Actions>
            <ButtonText onClick={onBack}>Voltar</ButtonText>
          </S.Actions>
        )}
      </div>
    </S.Container>
  );
}

export default AnteriorTab;
